export default {
  SET(state, values) {
    for (let k in values) {
      state.data[k] = values[k];
    }
  },
};
